// App views: name in the URL (#/name) → component.
import type { Component } from "svelte";
import Dashboard from "./Dashboard.svelte";
import Holdings from "./Holdings.svelte";
import Allocation from "./Allocation.svelte";
import Performance from "./Performance.svelte";
import Returns from "./Returns.svelte";
import Attribution from "./Attribution.svelte";
import Purchases from "./Purchases.svelte";
import BondCalendar from "./BondCalendar.svelte";
import Ike from "./Ike.svelte";
import Projection from "./Projection.svelte";
import Alternative from "./Alternative.svelte";
import Taxes from "./Taxes.svelte";
import Costs from "./Costs.svelte";
import CashFlows from "./CashFlows.svelte";
import Transactions from "./Transactions.svelte";
import Import from "./Import.svelte";
import Settings from "./Settings.svelte";

export const VIEWS: Record<string, Component> = {
  dashboard: Dashboard, holdings: Holdings, allocation: Allocation, performance: Performance, returns: Returns, attribution: Attribution, purchases: Purchases,
  bonds: BondCalendar, ike: Ike, projection: Projection, alternative: Alternative,
  taxes: Taxes, costs: Costs, cashflows: CashFlows, transactions: Transactions, import: Import, settings: Settings,
};
